import React, { memo } from 'react';
import { LoadingScreen } from '../../../../common/components/LoadingScreen';

type LoadingState = {
  isLoading: boolean;
  loadingMessage?: string;
};

export const RegenerationLoading: React.FC<LoadingState> = memo(
  ({ isLoading, loadingMessage = 'Processing regeneration request...' }) => {
    if (!isLoading) {
      return null;
    }

    return <LoadingScreen message={loadingMessage} />;
  },
);
